
    <div class="ModalContainer"
      (click)="$event.stopPropagation()"
      [ngClass]="{
        SmallSize: size === 'small',
        LargeSize: size === 'large'
      }"
    >
      <ng-container #modalContent></ng-container>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/@shared/ui/modal/modal.component.ts.ModalComponent.html